/**
 * Strategy libraries — grid / DCA deployable agent configs (Advanced+).
 * Not signal marketplaces or copy-trading feeds.
 */

export {
  DeployAsAgentButton,
  type DeployAsAgentButtonProps,
  type DeployAsAgentMode,
  type LibraryTemplateKind,
} from './DeployAsAgentButton'

export {
  GridLibrary,
  type GridLibraryProps,
} from './GridLibrary'

export {
  GRID_TEMPLATES,
  getGridTemplate,
  listGridTemplates,
  type GridTemplate,
  type GridTemplateId,
  type GridTemplateDefaults,
} from './grid-templates'

export {
  DcaLibrary,
  type DcaLibraryProps,
} from './DcaLibrary'

export {
  DCA_TEMPLATES,
  getDcaTemplate,
  listDcaTemplates,
  type DcaTemplate,
  type DcaTemplateId,
  type DcaTemplateDefaults,
} from './dca-templates'
